// // src/StockDetails.js
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Table } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar'


// const StockDetails = () => {
//     const [stockData, setStockData] = useState([]);
    
//     useEffect(() => {
//         // Fetch stock data from the back-end API
//         axios.get('https://posapi.emedha.in/api/api/stock')
//             .then(response => {
//                 setStockData(response.data);
//             })
//             .catch(error => {
//                 console.error('There was an error fetching the stock data!', error);
//             });
//     }, []);
    
//     return (
//         <>
//         <Sidebar />
//         <div id='main'>
//         <div className="container mt-5">
//             <h1>Stock Details</h1>
//             <hr />
//             <Table striped bordered hover responsive>
//                 <thead>
//                     <tr>
//                         <th>S.No</th>
//                         <th>Product Name</th>
//                         <th>Weight Per Quantity</th>
//                         <th>QR Code</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {stockData.map((item, index) => (
//                         <tr key={item.sno}>
//                             <td>{index + 1}</td>
//                             <td>{item.cat_name}</td>
//                             <td>{item.quantity}</td>
//                             <td>
//                                 <img src={item.qrimg} alt="QR Code" style={{ width: '40%' }} />
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </Table>
//         </div>
//         </div>
//         </>
//     );
// }

// export default StockDetails;


// src/StockDetails.js




// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Table, Pagination, DropdownButton, Dropdown } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar'

// const StockDetails = () => {
//     const [stockData, setStockData] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [perPage, setPerPage] = useState(10); // Default items per page
//     const [totalCount, setTotalCount] = useState(0);

//     // Fetch all stock data
//     useEffect(() => {
//         axios.get('https://posapi.emedha.in/api/api/stock')
//             .then(response => {
//                 setStockData(response.data);
//                 setTotalCount(response.data.length); // Total items for pagination
//             })
//             .catch(error => {
//                 console.error('There was an error fetching the stock data!', error);
//             });
//     }, []);

//     // Calculate the current page data to display
//     const indexOfLastItem = currentPage * perPage;
//     const indexOfFirstItem = indexOfLastItem - perPage;
//     const currentItems = stockData.slice(indexOfFirstItem, indexOfLastItem);

//     // Calculate the total number of pages
//     const totalPages = Math.ceil(totalCount / perPage);

//     // Handle page change
//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Handle items per page change
//     const handlePerPageChange = (num) => {
//         setPerPage(num);
//         setCurrentPage(1); // Reset to the first page when perPage changes
//     };

//     // Pagination range logic
//     const paginationRange = () => {
//         const range = [];
//         const maxPagesToShow = 5; // Maximum number of pages to show
//         let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
//         let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

//         // Adjust range if there are fewer than maxPagesToShow pages
//         if (endPage - startPage + 1 < maxPagesToShow) {
//             startPage = Math.max(1, endPage - maxPagesToShow + 1);
//         }

//         // Collect the range of pages to display
//         for (let i = startPage; i <= endPage; i++) {
//             range.push(i);
//         }

//         return range;
//     };

//     const renderPagination = () => {
//         const range = paginationRange();
//         const paginationItems = [];

//         // Previous button
//         paginationItems.push(
//             <Pagination.Prev
//                 key="prev"
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//             />
//         );

//         // Display first page if needed
//         if (range[0] > 1) {
//             paginationItems.push(
//                 <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
//                     1
//                 </Pagination.Item>
//             );
//             paginationItems.push(<Pagination.Ellipsis key="ellipsis-left" />);
//         }

//         // Display the current page range
//         range.forEach((page) => {
//             paginationItems.push(
//                 <Pagination.Item
//                     key={page}
//                     active={page === currentPage}
//                     onClick={() => handlePageChange(page)}
//                 >
//                     {page}
//                 </Pagination.Item>
//             );
//         });

//         // Display last page if needed
//         if (range[range.length - 1] < totalPages) {
//             paginationItems.push(<Pagination.Ellipsis key="ellipsis-right" />);
//             paginationItems.push(
//                 <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
//                     {totalPages}
//                 </Pagination.Item>
//             );
//         }

//         // Next button
//         paginationItems.push(
//             <Pagination.Next
//                 key="next"
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//             />
//         );

//         return paginationItems;
//     };

//     return (


//         <>
//         <Sidebar/>
//         <div id='main'>
//         <div className="container mt-5">
//             <h1>Stock Details</h1>
//             <hr />
//             {/* Select items per page */}
//             <div className="d-flex justify-content-between mb-3">
//                 <DropdownButton
//                     id="dropdown-basic-button"
//                     title={`Show ${perPage} items per page`}
//                     onSelect={handlePerPageChange}
//                 >
//                     <Dropdown.Item eventKey={10}>10</Dropdown.Item>
//                     <Dropdown.Item eventKey={20}>20</Dropdown.Item>
//                     <Dropdown.Item eventKey={30}>30</Dropdown.Item>
//                     <Dropdown.Item eventKey={40}>40</Dropdown.Item>
//                 </DropdownButton>
//             </div>

//             {/* Table to display data */}
//             <Table striped bordered hover responsive>
//                 <thead>
//                     <tr>
//                         <th>S.No</th>
//                         <th>Product Name</th>
//                         <th>Weight Per Quantity</th>
//                         <th>Price</th>
//                         <th>QR Code</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {currentItems.map((item, index) => (
//                         <tr key={item.sno}>
//                             <td>{(currentPage - 1) * perPage + index + 1}</td>
//                             <td>{item.cat_name}</td>
//                             <td>{item.quantity}</td>
//                             <td>{item.pricee}</td>
//                             <td>
//                                 <img src={item.qrimg} alt="QR Code" style={{ width: '40%' }} />
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </Table>

//             {/* Pagination */}
//             <Pagination>{renderPagination()}</Pagination>
//         </div>
//         </div>

//         </>
//     );
// };

// export default StockDetails;



import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar/Sidebar';

// Self-contained SVG Icons
const Icons = {
  Search: (size = 16) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  )
};

const StockDetails = () => {
  const [stockData, setStockData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  // Responsive state
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch all stock data
  useEffect(() => {
    setLoading(true);
    axios.get('https://posapi.emedha.in/api/api/stock')
      .then(response => {
        setStockData(response.data || []);
        setTotalCount((response.data || []).length);
      })
      .catch(error => {
        console.error('There was an error fetching the stock data!', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Filtered stock list
  const filteredStock = useMemo(() => {
    return stockData.filter((item) => {
      const q = searchQuery.toLowerCase();
      return (
        (item.cat_name && item.cat_name.toLowerCase().includes(q)) ||
        (item.quantity && item.quantity.toString().toLowerCase().includes(q)) ||
        (item.pricee && item.pricee.toString().toLowerCase().includes(q))
      );
    });
  }, [stockData, searchQuery]);

  // Pagination calculations
  const totalPages = Math.ceil(filteredStock.length / perPage) || 1;
  const indexOfFirstItem = (currentPage - 1) * perPage;
  const currentItems = filteredStock.slice(indexOfFirstItem, indexOfFirstItem + perPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePerPageChange = (num) => {
    setPerPage(Number(num));
    setCurrentPage(1);
  };

  // Smart Pagination Calculation
  const getPaginationItems = () => {
    if (totalPages <= 8) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 4) {
      return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    if (currentPage >= totalPages - 3) {
      return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
  };

  return (
    <div 
    //style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    >
      <Sidebar />

      <div
        id="main"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '1280px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'space-between',
              gap: '16px',
              width: '100%'
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? '22px' : '26px',
                  fontWeight: '700',
                  color: '#111827',
                  fontFamily: "'Cinzel', serif"
                }}
              >
                Stock Details
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
                View product inventory, weights, pricing, and scannable QR codes
              </p>
            </div>
          </div>

          {/* Main Content Table Container */}
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              border: '1px solid #ffedd5',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              width: '100%',
              overflow: 'hidden'
            }}
          >
            {/* Toolbar */}
            <div
              style={{
                padding: '16px 20px',
                borderBottom: '1px solid #ffedd5',
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isMobile ? 'stretch' : 'center',
                gap: '12px',
                backgroundColor: '#ffffff'
              }}
            >
              <div style={{ position: 'relative', flex: 1, maxWidth: isMobile ? '100%' : '420px' }}>
                <span
                  style={{
                    position: 'absolute',
                    left: '14px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#9ca3af',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {Icons.Search(16)}
                </span>
                <input
                  placeholder="Search by Product Name, Quantity, or Price..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{
                    width: '100%',
                    padding: '11px 16px 11px 40px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Items per page selector */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#4b5563' }}>
                <span>Show</span>
                <select
                  value={perPage}
                  onChange={(e) => handlePerPageChange(e.target.value)}
                  style={{
                    padding: '8px 12px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    backgroundColor: '#ffffff',
                    color: '#1f2937',
                    outline: 'none',
                    cursor: 'pointer'
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                </select>
                <span>entries</span>
              </div>
            </div>

            {/* Table */}
            {loading ? (
              <div style={{ textAlign: 'center', padding: '50px 0', color: '#6b7280', fontSize: '14px' }}>
                Loading stock details...
              </div>
            ) : (
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <table
                  style={{
                    width: '100%',
                    minWidth: '750px',
                    borderCollapse: 'collapse',
                    textAlign: 'left'
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        backgroundColor: 'rgba(255, 247, 237, 0.6)',
                        borderBottom: '1px solid #ffedd5',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#374151',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em'
                      }}
                    >
                      <th style={{ padding: '14px 20px', width: '70px' }}>S.No</th>
                      <th style={{ padding: '14px 20px' }}>Product Name</th>
                      <th style={{ padding: '14px 20px' }}>Weight Per Quantity</th>
                      <th style={{ padding: '14px 20px' }}>Price</th>
                      <th style={{ padding: '14px 20px', width: '160px' }}>QR Code</th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: '14px' }}>
                    {currentItems.length > 0 ? (
                      currentItems.map((item, index) => {
                        const serialNumber = indexOfFirstItem + index + 1;
                        return (
                          <tr
                            key={item.sno || index}
                            style={{
                              borderBottom: '1px solid #fff7ed',
                              backgroundColor: '#ffffff'
                            }}
                          >
                            <td style={{ padding: '16px 20px', color: '#6b7280', fontWeight: '500', fontSize: '13px' }}>
                              {serialNumber}
                            </td>
                            <td style={{ padding: '16px 20px', fontWeight: '600', color: '#111827' }}>
                              {item.cat_name}
                            </td>
                            <td style={{ padding: '16px 20px' }}>
                              <span
                                style={{
                                  display: 'inline-block',
                                  padding: '4px 10px',
                                  borderRadius: '9999px',
                                  fontSize: '12px',
                                  fontWeight: '500',
                                  backgroundColor: '#fff7ed',
                                  color: '#c2410c',
                                  border: '1px solid #ffedd5'
                                }}
                              >
                                {item.quantity}
                              </span>
                            </td>
                            <td style={{ padding: '16px 20px', fontWeight: '700', color: '#111827' }}>
                              ₹{Number(item.pricee || 0).toLocaleString()}
                            </td>
                            <td style={{ padding: '12px 20px' }}>
                              {item.qrimg ? (
                                <div
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '4px',
                                    backgroundColor: '#ffffff',
                                    borderRadius: '10px',
                                    border: '1px solid #ffedd5',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                                  }}
                                >
                                  <img
                                    src={item.qrimg}
                                    alt="QR Code"
                                    style={{
                                      width: '64px',
                                      height: '64px',
                                      objectFit: 'contain',
                                      display: 'block'
                                    }}
                                  />
                                </div>
                              ) : (
                                <span style={{ color: '#9ca3af', fontSize: '12px' }}>No QR</span>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: 'center',
                            padding: '40px 0',
                            color: '#9ca3af',
                            fontSize: '14px'
                          }}
                        >
                          No stock items found matching your filter criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* Smart Pagination Controls */}
            {totalPages > 1 && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px',
                  padding: '16px 20px',
                  borderTop: '1px solid #ffedd5',
                  backgroundColor: '#ffffff',
                  flexWrap: 'wrap'
                }}
              >
                <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
                  Showing {indexOfFirstItem + 1} to{' '}
                  {Math.min(indexOfFirstItem + perPage, filteredStock.length)} of {filteredStock.length} entries
                </p>

                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                  {/* First Page */}
                  <button
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: '6px 10px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                      opacity: currentPage === 1 ? 0.4 : 1
                    }}
                  >
                    « First
                  </button>

                  {/* Previous */}
                  <button
                    onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                    disabled={currentPage === 1}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                      opacity: currentPage === 1 ? 0.4 : 1
                    }}
                  >
                    Prev
                  </button>

                  {/* Page Numbers & Ellipsis */}
                  {getPaginationItems().map((item, index) => {
                    if (item === '...') {
                      return (
                        <span
                          key={`ellipsis-${index}`}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '28px',
                            height: '32px',
                            fontSize: '14px',
                            color: '#9ca3af',
                            userSelect: 'none'
                          }}
                        >
                          ...
                        </span>
                      );
                    }

                    const isCurrent = currentPage === item;
                    return (
                      <button
                        key={`page-${item}`}
                        onClick={() => handlePageChange(item)}
                        style={{
                          minWidth: '32px',
                          height: '32px',
                          padding: '0 6px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          fontWeight: isCurrent ? '700' : '500',
                          cursor: 'pointer',
                          border: isCurrent ? 'none' : '1px solid #e5e7eb',
                          backgroundColor: isCurrent ? '#f97316' : '#ffffff',
                          color: isCurrent ? '#ffffff' : '#4b5563',
                          boxShadow: isCurrent ? '0 2px 8px rgba(249, 115, 22, 0.3)' : 'none'
                        }}
                      >
                        {item}
                      </button>
                    );
                  })}

                  {/* Next */}
                  <button
                    onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                      opacity: currentPage === totalPages ? 0.4 : 1
                    }}
                  >
                    Next
                  </button>

                  {/* Last Page */}
                  <button
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: '6px 10px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                      opacity: currentPage === totalPages ? 0.4 : 1
                    }}
                  >
                    Last »
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockDetails;